import React from 'react';
import Skills from './Skills.js';
import Tilt from 'react-parallax-tilt';
import Lottie from "lottie-react"
import Coder from '../LottieFiles/coder.json';

const About = () => {
  return (
    <>
      <div className='AboutPage'>
        <div className='AboutText'>
          <h1 className='AboutTextHeading' >Get to <b>know</b> me!</h1>
          <p>
            Hi, my name is <b>MOHAMED GAMAL</b> and I am from Zagazig, Egypt.
            I'm a software engineer specialized in <b>Android & Flutter Developer</b> skilled in designing and building high-performance, user-friendly apps. <br /><br />
            Proficient in <b>Java</b>, <b>Kotlin</b>, and the <b>Android SDK</b>, with expertise in UI/UX, coding, testing, and deployment.
            Focuses on app optimization, security, and feature integration.<br /><br />
            Proven team leader and collaborator, committed to delivering innovative Android solutions and
            staying current with industry trends.<br /><br />
            I am <b>open</b> to new collaborations or work where I can contribute and grow. Feel free to connect with me, links are in the footer.<br />
            {/* Apart from coding I love to do , you can check out some of my shots here <a href="" target='_blank'>Instagram.</a> */}
          </p>
        </div>

        <div>
          <Tilt>
            <Lottie
              className="illustration"
              animationData={Coder}
              loop={true}
            />
          </Tilt>
        </div>

      </div>

      <h1 className='SkillsHeading'>Mobile Skills</h1>
      <div className='skills'>

        <Skills skill='Android' />
        <Skills skill='Flutter' />
        <Skills skill='Java' />
        <Skills skill='Kotlin' />
        <Skills skill='Dart' />

      </div>

      <h1 className='SkillsHeading'>Backend Skills</h1>

      <div className='skills'>
        <Skills skill='Javascript' />
        <Skills skill='NodeJs' />
        <Skills skill='Express' />
        <Skills skill='MongoDb' />

      </div>

      <h1 className='SkillsHeading'>Other Skills</h1>

      <div className='skills'>

        <Skills skill='Git' />
        <Skills skill='Github' />
        <Skills skill='Postman' />
        <Skills skill='Vercel' />
        <Skills skill='Npm' />
        <Skills skill='Figma' />

        <Skills skill='C++' />

      </div>
    </>
  )
}

export default About